import type { MailboxInfo } from "owa-client-types";
import { getMailboxInfo } from "../../selectors/mailRowDataPropertyGetter";
import type TableView from "../../store/schema/TableView";
import mailStore from "owa-mail-store/lib/store/Store";

/**
 * Resolves the MailboxInfo for a given row key or item ID.
 * Tries the tableView selector first (row key lookup), then falls back
 * to the mail store (item ID lookup).
 */
export function getMailboxInfoFromRowKeyOrId(rowKeyOrId: string, tableView?: TableView): MailboxInfo | undefined {
    if (tableView) {
        return (getMailboxInfo(rowKeyOrId, tableView) ?? mailStore().items.get(rowKeyOrId)?.MailboxInfo);
    }
    return mailStore().items.get(rowKeyOrId)?.MailboxInfo;
}
